import { useLocalStorage } from "@/hooks/useLocalStorage";
import { useUserId } from "@/features/auth/hooks/useUserId";

/**
 * Whether the account has dismissed the withdrawal processing window alert.
 * Once dismissed it stays dismissed, so the note doesn't reappear on every
 * withdrawal.
 */
export const useWithdrawalWindowAlertDismissed = () => {
  const userId = useUserId() ?? "anonymous";

  return useLocalStorage<boolean>(
    `withdrawalWindowAlertDismissed:${userId}`,
    false,
  );
};
